import { AnchorButton } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import Link from "next/link";
import React from "react";
import { FormattedMessage } from "react-intl";
import ProjectIcon from "~/components/icons/ProjectIcon";

interface IInviteGovernmentsPlaceholderProps {
  slug: string;
  onClickToggle?: () => void;
}

export default function InviteGovernmentsPlaceholder({ slug, onClickToggle }: IInviteGovernmentsPlaceholderProps) {
  return (
    <div
      css={{
        background: "#fff",
        border: `1px solid ${palette.lightestGray}`,
        padding: 24,
      }}
    >
      <div
        css={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 400,
          margin: "0 auto",
        }}
      >
        <ProjectIcon width={60} height={60} />

        <p
          css={{
            margin: "12px 0 0 0",
            color: palette.text,
            fontWeight: 500,
            fontSize: 16,
          }}
        >
          <FormattedMessage defaultMessage="Invite your connections" id="svU0CY" />
        </p>

        <p
          css={{
            margin: "12px 0 0 0",
            color: palette.darkGray,
            fontSize: 14,
          }}
        >
          <FormattedMessage defaultMessage="Connect with your government customers so your products are added to their stacks." id="355747" />
        </p>

        {onClickToggle ? (
          <AnchorButton
            size="small"
            color={palette.innovatorBlue}
            onClick={onClickToggle}
            theme="secondary"
            css={{
              margin: "12px 0 0 0",
              minWidth: 150,
            }}
          >
            <FormattedMessage defaultMessage="Add Governments" id="1hAbkF" />
          </AnchorButton>
        ) : (
          <Link href="/vendors/[vendorSlug]/[[...content]]" as={`/vendors/${slug}/invite-governments`} passHref={true}>
            <AnchorButton
              size="small"
              color={palette.innovatorBlue}
              theme="secondary"
              css={{
                margin: "12px 0 0 0",
                minWidth: 150,
              }}
            >
              <FormattedMessage defaultMessage="Add Governments" id="1hAbkF" />
            </AnchorButton>
          </Link>
        )}
      </div>
    </div>
  );
}
